import { FallbackError } from "@core/domain/errors/fallback.error";
import { Either } from "@core/domain/types/either";
import { BudgetRepository } from "@project/data/repositories/budget.repository";
import { inject, injectable } from "inversify";

export interface ExpenseTypeOption {
    value: string;
    label: string;
}

@injectable()
export class GetCategoryGroupExpenseTypesUseCase {
    constructor(
        @inject(BudgetRepository)
        private readonly budgetRepository: BudgetRepository,
    ) { }

    async execute(): Promise<ExpenseTypeOption[]> {
        const expenseTypesResult =
            await this.budgetRepository.getCategoryGroupExpenseTypes();

        return expenseTypesResult.getOrElse([]);
    }
}
